import LyricsRow from './LyricsRow'

export default LyricsRow
